import React from "react";
import Modal from "../../ui-components/Modal";
import _ from "lodash";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/solid";
import { ClipboardDocumentListIcon } from "@heroicons/react/24/outline";
import AuthenticationService from "../../services/AuthenticationService";

const ConnectionsSurveyModal = ({
  intl,
  surveys,
  countryCode,
  worksiteTypes,
  onExit = () => {},
}) => {
  const userData = AuthenticationService.getUserData();

  // utilities
  const lkpType = worksiteTypes.reduce(
    (obj, i) => _.set(obj, [i.cod_worksite_type], i.icon_name),
    {}
  );

  return (
    <Modal {...{ onExit }}>
      <label className="block text-lg font-bold mb-3">
        {intl.formatMessage({ id: "configurations" })}
      </label>
      {surveys?.map((s, idx) => (
        <div key={idx} className="w-full flex items-center gap-x-3 my-3">
          <ClipboardDocumentListIcon className="w-12 h-12" />
          <div className="flex-1">
            <p className="font-semibold mb-1">{s.service_name}</p>
            {/*<p className="text-xs italic mb-1">{s.service_description}</p>*/}
            <div className="flex items-center text-xs gap-1">
              {/*<span>{intl.formatMessage({id: 'worksite'})}: </span>*/}
              <img
                src={lkpType[s.cod_worksite_type]}
                alt={intl.formatMessage({ id: s.cod_worksite_type })}
                className="w-5 h-5"
              />
              <span>{s.des_worksite}</span>
            </div>
          </div>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`/${countryCode}/worksites/${s.worksite_id}/service/${s.service_id}/survey/${s.id}`}
          >
            <ArrowTopRightOnSquareIcon
              className={`w-6 h-6 mx-3 text-${userData.business}-400`}
            />
          </a>
        </div>
      ))}
    </Modal>
  );
};

export default ConnectionsSurveyModal;
